var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c(_vm.input.component.name,{tag:"component",attrs:{"form":_vm.form,"input":_vm.input,"rowdata":_vm.rowdata,"rowall":_vm.rowall}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }